import {WindowParam} from "../../../library/context/WindowContext";
import {SizeAttr} from "../../../library/basic/size";

export type SizeRange = "pc-full" | "pc" | "pad" | "phone"

export function getSizeRange(wp: WindowParam): SizeRange {
    if (wp.currWidth >= 1600) {
        return "pc-full"
    }
    if (wp.currWidth >= 960) {
        return "pc"
    }
    if (wp.currWidth >= 600) {
        return "pad"
    }
    return "phone"
}

export function isSizeRangePcFull(wp: WindowParam): boolean {
    return getSizeRange(wp) == "pc-full"
}

export function isSizeRangePc(wp: WindowParam): boolean {
    return getSizeRange(wp) == "pc"
}

export function isSizeRangePcOrPcFull(wp: WindowParam): boolean {
    return isSizeRangePc(wp) || isSizeRangePcFull(wp)
}

export function isSizeRangePad(wp: WindowParam): boolean {
    return getSizeRange(wp) == "pad"
}

export function isSizeRangePcOrPad(wp: WindowParam): boolean {
    return isSizeRangePc(wp) || isSizeRangePad(wp)
}

export function isSizeRangePhone(wp: WindowParam): boolean {
    return getSizeRange(wp) == "phone"
}

export function getTopNavHeight(wp: WindowParam): string {
    return isSizeRangePcOrPcFull(wp) ? "84px" : "68px"
}

export function getOfficialInnerColWidth(wp: WindowParam): string {
    return isSizeRangePcFull(wp) ? "1600px" : SizeAttr.changeVwToPx(wp, "100vw")
}

export function getOfficialHorizontalMargin(wp: WindowParam): string {
    if (isSizeRangePhone(wp)) return "24px"
    if (wp.currWidth >= 1280) return "114px"
    return "40px"
}

export function getOfficialInnerSectionWidth(wp: WindowParam): string {
    let colWidthPx = SizeAttr.getPxNumber(getOfficialInnerColWidth(wp))
    let marginPx = SizeAttr.getPxNumber(getOfficialHorizontalMargin(wp))
    return (colWidthPx - 2 * marginPx) + "px"
}

export function getOfficialBottomHeight(wp: WindowParam): string {
    return wp.currWidth <= 720 ? "195px" : "155px"
}
